import axios from "axios";

export default function SupervisoryunitstatusListService() {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/supervisory_unit_sync_status",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
